// extracted by mini-css-extract-plugin
module.exports = {"artist":"ImportArtistSearchResult-artist-11vxQ"};